import * as Constants from "../../constants";
import * as Enums from "../../enums";
import {
  resolveHardOfHearingLabel,
  resolveTranslationLabel,
  resolveTwoLetterCode
} from "../../helpers/language";
import { SubtitlesDefault } from "../../types/common";
import { Subtitles } from "../../types/player-api";

const findUserPreferredSubtitles = (
  subtitles: Subtitles[],
  userPreferredSubtitles?: Subtitles
) =>
  userPreferredSubtitles &&
  (subtitles.some(
    s =>
      s.label?.toLowerCase() === userPreferredSubtitles?.label?.toLowerCase() &&
      s.language === userPreferredSubtitles?.language
  ) ||
    userPreferredSubtitles?.kind === Constants.SUBTITLES_OFF.kind);

export const resolveSelectedSubtitles = (
  uiLanguage: string,
  subtitles: Subtitles[],
  subtitlesEnabled: boolean,
  subtitlesDefault?: SubtitlesDefault,
  userPreferredSubtitles?: Subtitles
) => {
  if (!subtitlesEnabled || subtitles.length === 0) {
    return;
  }

  const hasUserPreferredSubtitles = findUserPreferredSubtitles(
    subtitles,
    userPreferredSubtitles
  );

  const twoLetterUiLanguageCode = resolveTwoLetterCode(uiLanguage);
  const translationSubtitles = subtitles.find(
    s =>
      s.label?.toLowerCase() ===
        resolveTranslationLabel(twoLetterUiLanguageCode) &&
      (s.language === twoLetterUiLanguageCode || s.language === uiLanguage)
  );
  const hardOfHearingSubtitles = subtitles.find(
    s =>
      s.label?.toLocaleLowerCase() ===
        resolveHardOfHearingLabel(twoLetterUiLanguageCode) &&
      (s.language === twoLetterUiLanguageCode || s.language === uiLanguage)
  );

  if (hasUserPreferredSubtitles) {
    return userPreferredSubtitles;
  } else if (
    subtitlesDefault === Enums.SUBTITLES_DEFAULT.hardOfHearing &&
    (hardOfHearingSubtitles || translationSubtitles)
  ) {
    return hardOfHearingSubtitles || translationSubtitles;
  } else if (
    subtitlesDefault === Enums.SUBTITLES_DEFAULT.translation &&
    translationSubtitles
  ) {
    return translationSubtitles;
  } else {
    return Constants.SUBTITLES_OFF;
  }
};
